import { baseUrl, forgerockErrors } from "../../utilities/configurations";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import { usePolicyContext } from "../../Contexts/AddPolicyContext";
import { KeyboardArrowLeft } from "@mui/icons-material";
import NumberField from "../../Components/NumberField";
import DatePicker from "../../Components/DatePicker";
import InputField from "../../Components/InputField";
import ErrorModal from "../../Components/ErrorModal";
import { FRAuth, StepType } from "@forgerock/javascript-sdk";
import { CircularProgress } from "@mui/material";
import apiRequest from "../../utilities/request";
import Button from "../../Components/Button";
import dayjs from "dayjs";
import {
  replacePayloadCBValueBasedOnPrompt,
  replaceCBValueBasedOnPrompt,
} from "../../Components/CustomFunctions";
import { startJourney, validateCardNumber } from "../../utilities/helper";
import { server_error_message, server_error_title } from "../../utilities/values";

function AddCard() {
  const {
    formatAndsetMaxicareCardNumber,
    setInitialAddPolicyData,
    personalMaxicareNumber,
    setConfigRestarted,
    setEmployeeNumber,
    setDisplayAlert,
    setAlertMessage,
    setCurrentStep,
    employeeNumber,
    setCompanyCode,
    setJourneyStep,
    setAlertTitle,
    setBirthDate,
    displayAlert,
    alertMessage,
    selectedType,
    setIsLoading,
    companyCode,
    currentStep,
    resetValues,
    alertTitle,
    handleBack,
    birthDate,
    isLoading,
    navigate,
  } = usePolicyContext();

  function nextButtonValidation() {
    if (selectedType === "Personal") {
      return personalMaxicareNumber.length !== 19 || !birthDate || isLoading;
    } else if (selectedType === "Corporate") {
      return (
        companyCode === "" || employeeNumber === "" || !birthDate || isLoading
      );
    }
  }

  function getContinueButtonClassname() {
    if (selectedType === "Personal") {
      if (personalMaxicareNumber.length !== 19 || !birthDate || isLoading) {
        return "bg-[#F6F7F7] text-[#A3A7AB]";
      } else {
        return "text-white";
      }
    } else if (selectedType === "Corporate") {
      if (
        companyCode === "" ||
        employeeNumber === "" ||
        !birthDate ||
        isLoading
      ) {
        return "bg-[#F6F7F7] text-[#A3A7AB]";
      } else {
        return "text-white";
      }
    }
  }

  const chooseSmsOtp = async (step3) => {
    try {
      const nextStep = await FRAuth.next(step3);
      switch(nextStep.type){
        case StepType.Step:
          navigate(`/add-policy/card-number/verify-otp`);
          setIsLoading(false);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] ||
                  forgerockErrors["SWW"]
              );
            }
            setIsLoading(false);
            resetValues();
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      console.log(err);
    }
  };

  const getOtherDetails = async (step2, member) => {
    let journey_obj = JSON.parse(JSON.stringify(step2));
    //if add membership card
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Member Status",
      member?.memberStatus
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Member Status",
      member?.memberStatus
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Member Type",
      member?.memberType
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Member Type",
      member?.memberType
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "PersonID",
      member?.personId
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "PersonID",
      member?.personId
    );
    //if add dependents
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Dependent Member Status",
      member?.memberStatus
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Dependent Member Status",
      member?.memberStatus
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Dependent Member Type",
      member?.memberType
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Dependent Member Type",
      member?.memberType
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Principal Member Status",
      "ACTIVE"
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Principal Member Status",
      "ACTIVE"
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Principal Member Type",
      "Principal"
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Principal Member Type",
      "Principal"
    );

    try {
      const nextStep = await FRAuth.next(journey_obj);
      switch(nextStep.type){
        case StepType.Step:
          setJourneyStep(nextStep);
          //choose otp type step
          if (nextStep.callbacks[0].getType() === "ChoiceCallback") {
            chooseSmsOtp(nextStep);
          } else {
            navigate(`/add-policy/card-number/verify-otp`);
            setIsLoading(false);
          }
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] ||
                  forgerockErrors["SWW"]
              );
            }
            setIsLoading(false);
            resetValues();
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      console.log(err);
    }
  };

  const proceedNext = async (step1, member) => {
    let journey_obj = JSON.parse(JSON.stringify(step1));
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Maxicare Card Number",
      member?.cardNo
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Maxicare Card Number",
      member?.cardNo
    );
    replaceCBValueBasedOnPrompt(
      journey_obj.callbacks,
      "Date of Birth",
      dayjs(birthDate).format("YYYY-MM-DD")
    );
    replacePayloadCBValueBasedOnPrompt(
      journey_obj.payload.callbacks,
      "Date of Birth",
      dayjs(birthDate).format("YYYY-MM-DD")
    );
    try {
      const nextStep = await FRAuth.next(journey_obj);
      switch(nextStep.type){
        case StepType.Step:
          setJourneyStep(nextStep);
          getOtherDetails(nextStep, member);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] ||
                  forgerockErrors["SWW"]
              );
            }
            setIsLoading(false);
            resetValues();
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      console.log(err);
    }
  };

  const initStep = async (member) => {
    try {
      const initialStep = await FRAuth.start({
        query: {
          ForceAuth: true
        }
      });
      setJourneyStep(initialStep);
      proceedNext(initialStep, member);
    } catch (err) {
      setIsLoading(false);
      setConfigRestarted(true);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      console.log(err);
    }
  };

  const initTree = (tree, member) => {
    startJourney(tree);
    setJourneyStep(null);
    initStep(member);
  };

  const verifyPolicy =async()=>{
    try {
      setIsLoading(true);
      const response = await apiRequest(
        baseUrl + "/policy/verify-policy",
        "POST",
        {
          cardNo: personalMaxicareNumber.replace(/\s/g, ""),
          birthDate: dayjs(birthDate).format("MM/DD/YYYY"),
          corpCode: companyCode,
          employeeId: employeeNumber,
          isIndividual: selectedType === "Personal",
        }
      );
      if (response.status) {
        let tree = process.env.REACT_APP_JOURNEY_ADD_DEPENDENT_CARD;
        if (response.data.isAdditionalCard) {
          tree = process.env.REACT_APP_JOURNEY_ADD_MEMBERSHIP_CARD;
        }
        initTree(tree, response.data);
        setInitialAddPolicyData(response.data);
      } else {
        setIsLoading(false);
        setDisplayAlert(true);
        const hasError = (
          response.message === "Member not found." ||
          response.message === "Policy is not eligible." ||
          response.message === "Policy does not exist." ||
          response.message === "Invalid birth date."
        )
        const messages = {
          "Personal": "Please double-check. Ensure your card number and birthdate are accurate and match our record",
          "Corporate": "Please double-check. Ensure your employee ID, corporate code, and birth date are accurate and match our records"
        }
        if(hasError){
          setAlertTitle("Oops! Incorrect info");
          setAlertMessage(messages[selectedType] || "");
        }else if (response.message) {
          setAlertTitle("Error");
          setAlertMessage(response.message);
        } else {
          setAlertTitle("Error");
          setAlertMessage("Something went wrong");
        }
      }
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      console.log(err);
    }
  }

  const handleNext = async () => {
    if(selectedType === "Personal" && !validateCardNumber(personalMaxicareNumber)){
      setDisplayAlert(true);
      setAlertTitle("Oops! Invalid card number");
      setAlertMessage("Please enter a valid card number.");
    }else{
      verifyPolicy();
    }
  };

  const handleClose = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  let content = null;
  let fields = null;
  if (selectedType === "Personal") {
    fields = (
      <div className="mt-2">
        <div className="font-semibold">Maxicare card number</div>
        <div className="mt-1">
          <NumberField
            id="maxicareNumber"
            type="text"
            placeholder="1168 0000 0000 0000"
            adornment={<PaymentOutlinedIcon sx={{ color: "#A3A7AB" }} />}
            value={personalMaxicareNumber}
            onChange={formatAndsetMaxicareCardNumber}
          />
        </div>
      </div>
    );
  } else if (selectedType === "Corporate") {
    fields = (
      <div className="mt-2">
        <div className="font-semibold">Company code</div>
        <div className="mt-1">
          <InputField
            id="companyCode"
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
          />
        </div>
        <div className="mt-2">
          <div className=" font-semibold">Employee ID</div>
          <div className="mt-1">
            <InputField
              id="employeeNumber"
              value={employeeNumber}
              onChange={(e) => setEmployeeNumber(e.target.value)}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-full bg-white rounded-xl sm:mt-5">
          <div className="w-full grid grid-cols-1 divide-y">
            <div className="p-4">
              <KeyboardArrowLeft
                className="absolute cursor-pointer"
                onClick={handleBack}
              />

              <div className="text-center font-semibold text-[#1F2328]">
                Add Policy
              </div>
            </div>
            <div className="p-4">
              <div>
                <div className="font-bold text-2xl text-[#1F2328]">
                  Enter your Maxicare card number
                </div>

                <div className="text-[#60656D] mt-2">
                  Access tailored healthcare services instantly with your Maxicare
                  card number
                </div>
              </div>
              {!displayAlert && alertMessage !== "" && (
                <span className="text-sm text-[#D32F2F]">{alertMessage}</span>
              )}
              <form onSubmit={handleNext}>
                {fields}
                <div className="mt-2">
                  <div className=" font-semibold">Date of birth</div>
                  <div className="mt-1">
                    <DatePicker
                      disablePast={false}
                      value={birthDate ? dayjs(birthDate) : null}
                      onChange={(newValue) => {
                        setBirthDate(dayjs(newValue).format("MM/DD/YYYY"));
                      }}
                      maxDate={dayjs().subtract(18, "years")}
                    />
                  </div>
                </div>
              </form>
              <div className="grid-5 sm:justify-items-start justify-items-center relative inset-x-0 bottom-0 sm:relative mt-3 ">
                <div className="text-[#60656D] text-center">
                  You will receive an OTP via SMS when you continue
                </div>
                <div className="bg-white flex-grow" />
                <div className="w-full sm:w-full grid justify-items-end mt-3">
                  <Button
                    disabled={nextButtonValidation()}
                    className={`w-full h-12 ${getContinueButtonClassname()}`}
                    onClick={handleNext}
                  >
                    {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleClose}
      />
    </div>
  );
}

export default AddCard;
